var render = function (_h,_vm) {var _c=_vm._c;return _c('div',[(_vm.props.isSupported)?_c('span',{staticClass:"supported"},[_vm._v("supported")]):_c('span',{staticClass:"not-supported"},[_vm._v("not supported")])])}
var staticRenderFns = []

export { render, staticRenderFns }